package com.rainbowclubs.rainbow.utils

class Validator {
    fun validatePassword(password: String): Boolean {
        if (password.length <= 8) {
            return false
        }
        val regex = Regex("^(?=.*[A-Za-z])(?=.*\\d).+$")
        return regex.matches(password)
    }

    fun validateRePassword(password: String, rePassword: String): Boolean {
        return password == rePassword
    }

    fun validateEmailFormat(email: String): Boolean {
        val regex = Regex("^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$")
        return regex.matches(email)
    }
}
